export default {
  title: 'Automatische maandelijkse flyers ontvangen',
  status: {
    enabled: 'Ingeschakeld',
    disabled: 'Uitgeschakeld',
  },
  opt_out: {
    on_hint: 'Uw FoodAmigos-abonnement omvat 500 gratis flyers per maand. Zet dit uit om ze niet meer te ontvangen.',
    off_hint: 'Automatische flyers zijn gepauzeerd. Zet aan om te hervatten vanaf de volgende maandelijkse versturing.',
    confirm_off: {
      title: 'Automatische flyers uitschakelen?',
      body: 'Als u dit uitschakelt, ontvangt {{location}} geen automatische flyers meer vanaf de volgende maandelijkse versturing. Bestaande bestellingen worden niet beïnvloed.',
      confirm: 'Uitschakelen',
      cancel: 'Aan houden',
    },
  },
  approved_design: {
    label: 'Goedgekeurd ontwerp voor maandelijkse flyers',
    auto_option: 'Automatisch (meest recent besteld)',
    flyer_slot: 'Flyer {{slot}}',
    custom: 'Aangepast',
    untitled: 'Naamloos',
    invalid_warning:
      'Het opgeslagen ontwerp is niet meer beschikbaar. De meest recent bestelde flyer wordt gebruikt totdat u een nieuwe kiest.',
  },
  toasts: {
    failed_to_load: 'Automatische flyerinstellingen laden mislukt',
    failed_to_save: 'Wijzigingen opslaan mislukt',
    saved: 'Wijzigingen opgeslagen',
  },
};
